import { render, staticRenderFns } from "./delete-quitclaim.vue?vue&type=template&id=8c490a84&scoped=true&"
import script from "./delete-quitclaim.vue?vue&type=script&lang=js&"
export * from "./delete-quitclaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c490a84",
  null
  
)

export default component.exports